import React from 'react';
import Input from '../../../../components/forms/Input';

const EventSenderInputs = ({ data, onInput }) => (
    <div className="ckp-admin-grid-row">
        <div className="ckp-admin-grid-column">
            <Input label="From name" value={data.name} onChange={onInput} disabled={false} name="name" />
            <Input label="From email" value={data.email} onChange={onInput} disabled={false} name="email" />
        </div>
    </div>
);

export default EventSenderInputs;
